import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.regexp.replace.js";
export default {
  formatACN: function formatACN(gn) {
    var txt = gn.replaceAll(' ', '');
    // eslint-disable-next-line
    var txta = txt.match(new RegExp('.{1,' + 3 + '}', 'g'));
    var ntxt = txta[0];
    if (txta[1]) {
      ntxt += " ".concat(txta[1]);
    }
    if (txta[2]) {
      ntxt += " ".concat(txta[2]);
    }
    return ntxt;
  },
  replaceAll: function replaceAll(search, replacement, val) {
    return val.replace(new RegExp(search, 'g'), replacement);
  },
  base64Encode: function base64Encode(val) {
    return btoa(val);
  },
  base64Decode: function base64Decode(val) {
    return atob(val);
  },
  base64EncodeObject: function base64EncodeObject(object) {
    return btoa(JSON.stringify(object));
  },
  base64DecodeObject: function base64DecodeObject(string) {
    return JSON.parse(atob(string));
  }
};